import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from '../../../utils/hooks';
import { Dropdown } from './dropdown';
export var Sort = function (_a) {
  var _b;
  var inDialog = _a.inDialog;
  var activitySearchStore = useStores().activitySearchStore;
  var sortSections = (_b = activitySearchStore.universalSortAndFilter) === null || _b === void 0 ? void 0 : _b.sortSections;
  if (!sortSections) {
    return React.createElement(React.Fragment, null);
  }
  return React.createElement(React.Fragment, null, sortSections.map(function (sortSection, index) {
    return React.createElement(UitkSpacing, {
      key: index,
      margin: {
        blockend: 'four',
        blockstart: 'two'
      },
      padding: {
        blockend: 'four'
      }
    }, React.createElement("section", {
      key: index,
      "data-testid": "sort-section"
    }, sortSection.fields.map(function (field, fieldIndex) {
      switch (field.__typename) {
        case 'ShoppingDropdownField':
          return React.createElement(Dropdown, {
            key: "dropdown-".concat(fieldIndex),
            field: field,
            inDialog: inDialog,
            title: field.primary
          });
        default:
          return React.createElement(React.Fragment, null);
      }
    })));
  }));
};